exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nh3[data-v-7c3ed7c1] {\n  margin: 40px 0 0;\n}\nul[data-v-7c3ed7c1] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-7c3ed7c1] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-7c3ed7c1] {\n  color: #42b983;\n}\n", "", {"version":3,"sources":["C:/Users/josea/Desktop/XelaCode/2022/Ferreteria la Colima 2022/Laraspace-Vue/resources/js/views/admin/pdf/Print.vue"],"names":[],"mappings":";AAAA;EACE,iBAAiB;CAAE;AAErB;EACE,sBAAsB;EACtB,WAAW;CAAE;AAEf;EACE,sBAAsB;EACtB,eAAe;CAAE;AAEnB;EACE,eAAe;CAAE","file":"Print.vue","sourcesContent":["h3 {\n  margin: 40px 0 0; }\n\nul {\n  list-style-type: none;\n  padding: 0; }\n\nli {\n  display: inline-block;\n  margin: 0 10px; }\n\na {\n  color: #42b983; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c3ed7c1","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/admin/pdf/Print.vue
// module id = 623
// module chunks = 0